import { usePolling } from '../hooks/usePolling'
import { poolsApi } from '../lib/api'
import PoolCard from '../components/PoolCard'

export default function PoolsPage() {
  const { data, loading, refetch } = usePolling({
    fetcher: () => poolsApi.list(),
    interval: 10000,
  })

  const pools = data?.pools || []

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Worker Pools</h1>
        <button
          onClick={() => refetch()}
          className="px-4 py-2 bg-brand-600 text-white text-sm rounded-md hover:bg-brand-700"
        >
          Refresh
        </button>
      </div>

      {loading && pools.length === 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white rounded-lg shadow p-6 animate-pulse">
              <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div className="h-16 bg-gray-200 rounded"></div>
                <div className="h-16 bg-gray-200 rounded"></div>
              </div>
              <div className="h-24 bg-gray-200 rounded"></div>
            </div>
          ))}
        </div>
      ) : pools.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <p className="text-gray-500 mb-4">No pools configured</p>
          <button className="px-4 py-2 bg-brand-600 text-white text-sm rounded-md hover:bg-brand-700">
            Create Pool
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pools.map((pool) => (
            <PoolCard key={pool.id} pool={pool} onUpdate={refetch} />
          ))}
        </div>
      )}
    </div>
  )
}
